<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Query Overrides</h3>

    <label>Post name query</label>
    <p class="hint">When the user submits their name (i.e. send a greeting)</p>
    <select v-model="resource.post_name_query_id">
      <option value="">-</option>
      <option v-for="query in queries" :key="query.id" :value="query.id">{{ query.label }}</option>
    </select>

    <hr />

    <label>Inline phone number query</label>
    <p class="hint">When a message contains a phone number (not when submitted via a form)</p>
    <select v-model="resource.inline_number_query_id">
      <option value="">-</option>
      <option v-for="query in queries" :key="query.id" :value="query.id">{{ query.label }}</option>
    </select>

    <label>Inline email address query</label>
    <p class="hint">When a message contains an email address (not when submitted via a form)</p>
    <select v-model="resource.inline_email_query_id">
      <option value="">-</option>
      <option v-for="query in queries" :key="query.id" :value="query.id">{{ query.label }}</option>
    </select>

    <hr />

    <label>Emoji query</label>
    <p class="hint">When a message contains only emojis</p>
    <select v-model="resource.emoji_query_id">
      <option value="">-</option>
      <option v-for="query in queries" :key="query.id" :value="query.id">{{ query.label }}</option>
    </select>

    <action-button class="-mt" :text="'Update Settings'" :state="state" @pressed="submit"></action-button>
  </div>
</template>

<script>
import { mapState } from "vuex";

import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: ["post_name_query_id", "inline_number_query_id", "inline_email_query_id", "emoji_query_id"]
    };
  },

  computed: {
    ...mapState({
      queries: (state) => state.queries.all
    })
  }
};
</script>
